module.exports = __webpack_public_path__ + "c557438dbc79eb25bb4c58296e49b303.svg";